import { ThemeProvider } from '@material-ui/core';
import { createTheme } from "@material-ui/core/styles";
import axios from "axios";
import MaterialTable from "material-table";
import { Component } from "react";
import { Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import ConfirmModal from "../utils/ConfirmModal";
import { hasPermission } from "../utils/usePermission";
import { DateTimeFormat } from './DateFormat/DateTimeFormat';
import CommonLoader from "./loaderComponent/CommonLoader";
import CommonToast from "./Toaster/CommonToast";

export default class ItemList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      loading: false,
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      showConfirm: false,
      deleteId: null,
      color: '',
    };
  }
  openConfirmModal = () => {
    this.setState({ showConfirm: true, });
  };
  closeConfirmModal = () => {
    this.setState({ showConfirm: false });
  };

  componentDidMount() {
    this.fetchItems();
  }

  fetchItems = () => {
    this.setState({ loading: true });
    const token = localStorage.getItem("token");
    axios
      .get("/items", { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        this.setState({ items: res.data, loading: false });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: error.response?.data?.message || "Error fetching items",
          toastVariant: "danger",
          color: 'red'
        });
      });
  };

  handleDelete = async () => {
    this.setState({ loading: true });

    const { deleteId } = this.state;
    const token = localStorage.getItem("token");

    try {
      await axios.delete(`/items/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      this.setState({
        showToast: true,
        toastMessage: "Item deleted successfully",
        toastVariant: "success",
        color: "green",
        showConfirm: false,
        deleteId: null,
        loading: false,
      });

      this.fetchItems(); // Refresh the data
    } catch (error) {
      this.setState({
        showToast: true,
        toastMessage: error.response?.data?.message || "Error deleting Item",
        toastVariant: "danger",
        color: "red",
        showConfirm: false,
        deleteId: null,
        loading: false,
      });
    }
  };


  handleMoveAdd = () => {
    this.props.history.push('/item-add')
  }

  handleEdit = (rowData) => {
    console.log("rowData", rowData);
    const { itemid } = rowData;
    this.props.history.push(`/item-add/${itemid}`, { data: rowData });
  };

  render() {
    const theme = createTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: '6px 6px 6px 6px'
          }
        }
      }
    })
    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <ConfirmModal
          show={this.state.showConfirm}
          onHide={() => this.setState({ showConfirm: false, deleteId: null })}
          onConfirm={() => this.handleDelete()}
          title="Delete Confirmation"
          loading={this.state.loading}
          message="Are you sure you want to delete this Item?"
        />
        <CommonLoader isLoading={this.state.loading}>
          <div className="container-fluid pt-4">
            <div className='d-flex search-btn-gap'>
              {
                hasPermission('M17S2B1') && (
                  <div className='add-role'>
                    <Button onClick={this.handleMoveAdd} variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button"> <i className="fa fa-plus-circle"></i> Add Item</Button>
                  </div>
                )
              }
            </div>
            <div className="col-sm-12">
              <Card>
                <Card.Header style={{ backgroundColor: "#515e73", color: "white" }}>
                  <div className="panel-title">
                    <strong>Item List</strong>
                  </div>
                </Card.Header>
                <Card.Body>
                  <ThemeProvider theme={theme}>
                    <MaterialTable
                      title="Item List"
                      columns={[
                        { title: "ID", field: "itemid", editable: "never" },
                        { title: "Name", field: "name" },
                        { title: "HSN Code", field: "hsnCode" },
                        { title: "UOM", field: "uomData.name" },
                        { title: "Description", field: "description" },
                        {
                          title: "Created Date", field: "createdAt",
                          render: (text) => DateTimeFormat(text.createdAt),
                        },
                        {
                          title: 'Action',
                          render: rowData => (
                            <>
                              {hasPermission('M17S2B3') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-delete-${rowData.id}`}>Edit Item</Tooltip>}
                                >
                                  <Button size="sm" variant="outline-info" className="mr-2 info"
                                    onClick={() => this.handleEdit(rowData)}
                                  >
                                    <i class="fa fa-edit"></i>
                                  </Button>
                                </OverlayTrigger>
                              )}
                              {hasPermission('M17S2B2') && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`tooltip-delete-${rowData.id}`}>Delete Item</Tooltip>}
                                >
                                  <Button size="sm" variant="outline-danger" className="mr-2 delete-btn"
                                    // onClick={() => this.handleDelete(rowData.itemid)}
                                    onClick={() => this.setState({ showConfirm: true, deleteId: rowData.itemid })}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </Button>
                                </OverlayTrigger>
                              )}
                            </>
                          )
                        }
                      ]}
                      data={this.state.items}
                      // actions={[
                      //   // {
                      //   //   icon: "add",
                      //   //   tooltip: "Add Item",
                      //   //   isFreeAction: true,
                      //   //   onClick: () => this.props.history.push("/item-add"),
                      //   // },
                      //   // {
                      //   //   icon: "delete",
                      //   //   tooltip: "Delete Item",
                      //   //   onClick: (event, rowData) => this.handleDelete(rowData.itemid),
                      //   // },
                      // ]}
                      options={{
                        pageSize: 10,
                        pageSizeOptions: [10, 20, 30, 50, 75, 100],
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: '#f2f2f2' }
                          }
                        },
                        actionsColumnIndex: -1,
                        search: true,
                        paging: true,
                      }}
                    />
                  </ThemeProvider>
                </Card.Body>
              </Card>
            </div>
          </div>
        </CommonLoader>
      </>
    );
  }
}
